import { essaiEchu, palierEffectifOrg } from '../api/mrr'
import { LIBELLE_PALIER } from '../api/abonnement'
import type { Organisation } from '../api/types'

export type ClasseBadge = 'vert' | 'info' | 'alerte' | 'rouge' | 'gris' | 'em'

export function Badge({ classe, children }: { classe: ClasseBadge; children: string }) {
  return <span className={`badge b-${classe}`}>{children}</span>
}

export function statutDe(o: Organisation, maintenant: Date): { classe: ClasseBadge; libelle: string } {
  if (o.is_operator) return { classe: 'gris', libelle: 'Sans objet' }
  switch (o.sub_status) {
    case 'active': return { classe: 'vert', libelle: 'Actif' }
    case 'trialing':
      return essaiEchu(o.sub_status, o.period_end, maintenant)
        ? { classe: 'alerte', libelle: 'Essai échu' }
        : { classe: 'info', libelle: 'Essai' }
    case 'past_due': return { classe: 'alerte', libelle: 'Impayé' }
    case 'cancelled': return { classe: 'rouge', libelle: 'Résilié' }
    default: return { classe: 'gris', libelle: 'Sans abonnement' }
  }
}

export function BadgePalier({ o }: { o: Organisation }) {
  if (o.is_operator) return <Badge classe="gris">Interne</Badge>
  const classe: ClasseBadge = o.plan_tier === 'pro' ? 'em' : o.plan_tier === 'business' ? 'info' : 'gris'
  return <Badge classe={classe}>{LIBELLE_PALIER[o.plan_tier]}</Badge>
}

/** « Appliqué : Starter » quand le palier réellement appliqué diffère du palier facturé (essai échu, résilié). */
export function palierDiverge(o: Organisation, maintenant: Date): string | null {
  if (o.is_operator) return null
  const eff = palierEffectifOrg(o, maintenant)
  return eff === o.plan_tier ? null : LIBELLE_PALIER[eff]
}
